import React from "react"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { currentUserIsInAdminRole as getCurrentUserIsInAdminRole } from "reduxSlices/sessionSlice"
import { REPORT_SFTP_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import {
  NOT_SCHEDULED_SFTP_OPTION,
  SCHEDULED_ACTIVE_SFTP_OPTION,
  SCHEDULED_INACTIVE_SFTP_OPTION,
} from "utils/reportHelpers"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import ReportIndexSidebarSftpSectionSftpCheckbox from "./ReportIndexSidebarSftpSectionSftpCheckbox"

const SFTP_OPTION_LABELS = {
  [SCHEDULED_ACTIVE_SFTP_OPTION]: "Scheduled - Active",
  [SCHEDULED_INACTIVE_SFTP_OPTION]: "Scheduled - Inactive",
  [NOT_SCHEDULED_SFTP_OPTION]: "Not Scheduled",
}

const ReportIndexSidebarSftpSection = () => {
  const currentUserIsInAdminRole = useSelector(getCurrentUserIsInAdminRole)
  const subscribedToSFTP = useSelector(subscribedToAddOnFeature(REPORT_SFTP_FEATURE_NAME))

  if (!currentUserIsInAdminRole || !subscribedToSFTP) return null

  return (
    <SidebarCollapsibleContent title="SFTP Uploads">
      {
        Object.entries(SFTP_OPTION_LABELS).map(([option, label]) => (
          <ReportIndexSidebarSftpSectionSftpCheckbox
            key={option}
            option={option}
            label={label}
          />
        ))
      }
    </SidebarCollapsibleContent>
  )
}

export default ReportIndexSidebarSftpSection
